/* istanbul ignore file */

export { Hero as default } from "./Hero";
